import { useSetAtom } from 'jotai'
import { ChallengeService } from '@duck/api-definitions'
import { apis } from '@modules/apiClients'
import { pendingWeaponPickAtom } from '@/store/workspaceAtoms'
import { useCanUsePython } from './useCanUsePython'

type BootArgs = {
  taskId: string
  assignmentId?: string
  allowedWeapons?: ChallengeService.TaskWeaponsOfChoiceEnum[]
}

export class WeaponPickCancelledError extends Error {
  constructor() {
    super('cancelled')
    this.name = 'WeaponPickCancelledError'
  }
}

export const useBootChallengeWithWeapon = () => {
  const setPending = useSetAtom(pendingWeaponPickAtom)
  const canUsePython = useCanUsePython()

  return async ({ taskId, assignmentId, allowedWeapons }: BootArgs) => {
    const weapons = (allowedWeapons && allowedWeapons.length > 0
      ? allowedWeapons
      : ['SQL'] as ChallengeService.TaskWeaponsOfChoiceEnum[])
    const shouldPick = weapons.length > 1 && canUsePython

    const chosenWeapon: ChallengeService.TaskWeaponsOfChoiceEnum = shouldPick
      ? await new Promise<ChallengeService.TaskWeaponsOfChoiceEnum>((resolve, reject) => {
          setPending({
            taskId,
            allowedWeapons: weapons,
            onPicked: resolve,
            onCancelled: () => reject(new WeaponPickCancelledError()),
          })
        })
      : weapons[0]

    return apis.challengeService.bootEnvironment({ taskId, assignmentId, chosenWeapon })
  }
}
